// extracted by mini-css-extract-plugin
module.exports = {"container":"IssueAction_container_1o1-T","button":"IssueAction_button_1rTAP","icon":"IssueAction_icon_7swbM","message":"IssueAction_message_1qC6G"};